var angular = require('angular')
var moment = require('moment')
require('../../services/appointments.service.js')
require('../../services/places.service.js')
require('../../services/app-data.service.js')
require('../../components/appointment-calendar-day/appointment-calendar-day.component.js')
require('../../components/appointment-branch-header/appointment-branch-header.component.js')
require('../../components/appointment-services/appointment-services.component.js')

angular.module('AemBranchesAppointments')
  .component('appointmentSelect', {
    template: require('./appointment-select.component.tpl.html'),
    controller: AppointmentSelectCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

AppointmentSelectCtrl.$inject = ['appLoader', 'appointmentsService', '$routeParams',
  'placesService', 'placesOpeningHoursService', '$window', 'appDataService',
  'userTracking']

function AppointmentSelectCtrl (appLoader, appointmentsService, $routeParams,
  placesService, placesOpeningHoursService, $window, appDataService,
  userTracking) {
  var vm = this

  vm.$onInit = function () {
    vm.error = null
    vm.branch = null
    vm.visibleDayRangeFromNow = { start: 0, end: 4, size: 5 }
    vm.timeslotsRange = getDateRange(
      moment().add(vm.visibleDayRangeFromNow.start, 'days').startOf('day').toDate(),
      moment().add(vm.visibleDayRangeFromNow.end, 'days').endOf('day').toDate())
      .map(function (date) {
        return {
          date: date,
          timeslots: []
        }
      })
    vm.nextDays = nextDays
    vm.prevDays = prevDays
    vm.serviceChange = serviceChange
    vm.assistance = appDataService.serviceGroups.ASSISTANCE.value
    vm.attendance = appDataService.serviceGroups.ATTENDANCE.value

    appLoader.show()
    placesService.branchDetail($routeParams.branchId)
      .then(function (res) {
        vm.branch = res.data
        userTracking.onResponse(vm.branch)
        return getBranchDateRangeTimeslots(vm.branch, vm.assistance, vm.attendance)
      })
      .then(function (res) {
        vm.timeslotsRange = res
      })
      .catch(function (err) {
        vm.error = err
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function filterOutagesForType(types) {
    return vm.branch.outages.filter(function(outage) {
      return types.indexOf(outage.outageType) !== -1
    })
  }

  function getBranchDateRangeTimeslots (branch, assistance, attendance) {
    var dateStart = moment().add(vm.visibleDayRangeFromNow.start, 'days').startOf('day').toDate()
    var dateEnd = moment().add(vm.visibleDayRangeFromNow.end, 'days').endOf('day').toDate()
    return appointmentsService.getFreeTimeSlots(dateStart, dateEnd, branch.id, appDataService.MEETING_LENGTH_MINUTES, assistance || null, attendance || null).then(function (res) {
      var openingHoursRange = getDateRange(dateStart, dateEnd).map(function (date) {
        return placesOpeningHoursService.normalizeToDate(branch.openingHours, filterOutagesForType(placesOpeningHoursService.outagesTypes), branch.accessType, date).todayOpening || { date: date }
      })
      var allTimeslotsRange = openingHoursRange.map(function (openingHours) {
        return {
          date: openingHours.date,
          timeslots: getIntervalTimeslots15(openingHours.date, openingHours.intervals)
        }
      })
      var openedTimeslotsRange = res.data || { timeslots: [] }
      return allTimeslotsRange.map(function (allTimeslotsDate) {
        allTimeslotsDate.timeslots = allTimeslotsDate.timeslots.map(function (timeslot) {
          timeslot.state = (!!openedTimeslotsRange.timeslots.filter(function (openedTimeslot) {
            return moment(openedTimeslot.start).isSame(timeslot.date, 'minute')
          }).length && 'FREE') || timeslot.state
          return timeslot
        })
        return allTimeslotsDate
      })
    })
  }

  function getDateRange (dateStart, dateEnd) {
    var range = []
    var i = 0
    var date = moment(dateStart).add(i, 'days').startOf('day')

    while (date.isSameOrBefore(dateEnd, 'day')) {
      range.push(date.toDate())
      date = moment(dateStart).add(++i, 'days').startOf('day')
    }

    return range
  }

  function getIntervalTimeslots15 (date, intervals) {
    var range = []

    if (intervals && intervals.length) {
      var from = intervals[0].from
      var to = intervals[intervals.length - 1].to

      for (var d = placesOpeningHoursService.getStartOfHourMinuteDate(date, from),
        dateTo = placesOpeningHoursService.getStartOfHourMinuteDate(date, to);
        d < dateTo; d = moment(d).add(15, 'minutes').toDate()) {
        range.push({
          date: d,
          daypartName: getDaypartName(d),
          state: placesOpeningHoursService.isDateInOpeningInterval(d, intervals) ? 'OCCUPIED' : 'CLOSED'
        })
      }
    }

    return range
  }

  function getDaypartName (date) {
    return [
      { name: 'MORNING', startHour: 0, endHour: 9 },
      { name: 'NOON', startHour: 10, endHour: 11 },
      { name: 'AFTERNOON', startHour: 12, endHour: 15 },
      { name: 'EVENING', startHour: 16, endHour: 23 }
    ].filter(function (element) {
      return new Date(date.getTime()).setHours(element.startHour, 0, 0, 0) <= date &&
        new Date(date.getTime()).setHours(element.endHour, 59, 59, 999) >= date
    })[0].name
  }

  function nextDays () {
    var end = vm.visibleDayRangeFromNow.end + vm.visibleDayRangeFromNow.size > 30 ? 30 : vm.visibleDayRangeFromNow.end + vm.visibleDayRangeFromNow.size

    if (vm.visibleDayRangeFromNow.end !== end) {
      vm.visibleDayRangeFromNow = {
        start: end - vm.visibleDayRangeFromNow.size + 1,
        end: end,
        size: vm.visibleDayRangeFromNow.size
      }

      appLoader.show()
      getBranchDateRangeTimeslots(vm.branch, vm.assistance, vm.attendance)
        .then(function (res) {
          vm.timeslotsRange = res
        })
        .catch(function (err) {
          vm.error = err
        })
        .finally(function () {
          appLoader.hide()
        })
    }
  }

  function prevDays () {
    var start = vm.visibleDayRangeFromNow.start - vm.visibleDayRangeFromNow.size < 0 ? 0 : vm.visibleDayRangeFromNow.start - vm.visibleDayRangeFromNow.size

    if (vm.visibleDayRangeFromNow.start !== start) {
      vm.visibleDayRangeFromNow = {
        start: start,
        end: start + vm.visibleDayRangeFromNow.size - 1,
        size: vm.visibleDayRangeFromNow.size
      }

      appLoader.show()
      getBranchDateRangeTimeslots(vm.branch, vm.assistance, vm.attendance)
        .then(function (res) {
          vm.timeslotsRange = res
        })
        .catch(function (err) {
          vm.error = err
        })
        .finally(function () {
          appLoader.hide()
        })
    }
  }

  angular.element($window).on('resize', debounce(function () {
    var size = Math.min(Math.floor($window.innerWidth / 240), 5)

    if (vm.visibleDayRangeFromNow.size !== size) {
      vm.visibleDayRangeFromNow = {
        start: vm.visibleDayRangeFromNow.start,
        end: vm.visibleDayRangeFromNow.start + size - 1,
        size: size
      }

      appLoader.show()
      getBranchDateRangeTimeslots(vm.branch, vm.assistance, vm.attendance)
        .then(function (res) {
          vm.timeslotsRange = res
        })
        .catch(function (err) {
          vm.error = err
        })
        .finally(function () {
          appLoader.hide()
        })
    }
  }, 1000))

  function serviceChange () {
    vm.assistance = appDataService.serviceGroups.ASSISTANCE.value
    vm.attendance = appDataService.serviceGroups.ATTENDANCE.value
    appLoader.show()
    getBranchDateRangeTimeslots(vm.branch, vm.assistance, vm.attendance)
      .then(function (res) {
        vm.timeslotsRange = res
      })
      .catch(function (err) {
        vm.error = err
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function debounce (func, wait, immediate) {
    var timeout
    return function () {
      var context = this
      var args = arguments
      var later = function () {
        timeout = null
        if (!immediate) func.apply(context, args)
      }
      var callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) func.apply(context, args)
    }
  }
}
